import { RedirectToSignIn, useAuth } from "@clerk/clerk-react";
import Loader from "components/common/loader";
import { selectCurrentSubscription } from "components/subscription/subscriptionSlice";
import { SUBSCRIPTION_STATUS } from "components/subscription/types";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ORGANIZATION_ROLE } from "layout/sidebar/types";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { isLoaded, isSignedIn } = useAuth();
  const currentSubscriptionDetails = useSelector(selectCurrentSubscription);
  const user = JSON.parse(localStorage.getItem("user")!);

  useEffect(() => {
    if (
      isLoaded &&
      isSignedIn &&
      (currentSubscriptionDetails?.status === SUBSCRIPTION_STATUS.CANCELLED ||
        currentSubscriptionDetails?.status === SUBSCRIPTION_STATUS.PASTDUE)
    ) {
      if (isLoaded && user?.organizationRole !== ORGANIZATION_ROLE.ADMIN) {
        navigate("../payment-overdue-member", { replace: true });
        return;
      } else {
        navigate("../billing", { replace: true });
      }
    }
  }, [
    isLoaded,
    isSignedIn,
    currentSubscriptionDetails?.status,
    navigate,
    user?.organizationRole,
  ]);

  if (!isLoaded) {
    return <Loader />;
  }

  if (!isSignedIn) {
    return <RedirectToSignIn signInFallbackRedirectUrl="/" />;
  }

  return <>{children}</>;
}
